import creditCardSVG from '../../assets/icons/credit-card.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const CreditCardIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={creditCardSVG} {...props} />;
};
